<div class="msg-wrapper">
    <section class="msgSection">
        <div class="card activated-msg d-flex flex-row justify-content-center">
            <i class="pr-3 align-middle {{msgBannerData.config.iconClass}}" aria-hidden="true"></i>
            <span *ngIf="msgBannerData.langFileKey">{{ msgBannerData.langFileKey | translate: msgBannerData.substitutions }}</span>
            <span *ngIf="!msgBannerData.langFileKey && msgBannerData.text">{{msgBannerData.text}}</span>
        </div>
    </section>
</div>
